const message = {
  uploading: "正在上传",
  documentName: "文件名称",
  editDocumentName: "修改文件名称",
};

export default message;
